/* @flow */

import { uniq } from 'ramda';
import * as marketTypes from 'src/shared/app/market/action/marketActionTypes';
import {
  createReducer,
  setRequestResultUniqAndValidate,
  invalidate,
  setFetchingState,
  unsetFetchingState,
} from 'src/shared/core/util/reducerUtils';
import * as types from 'src/shared/domain/user/action/userActionTypes.js';

const initialState = {
  isInvalidated: false,
  isFetching: false,
  isLazyFetching: false,
  result: [],
  count: null,
  next: null,
  previous: null,
};

const _lazyFetchUsersRequest = (state: Object) => ({
  ...state,
  isLazyFetching: true,
});

const _lazyFetchUsersSuccess = (state: Object, action: Object) => {
  const { result } = state;
  const { result: newResult, next } = action;

  return {
    ...state,
    isLazyFetching: false,
    result: uniq([...result, ...newResult]),
    next,
  };
};

const _lazyFetchUsersFailure = (state: Object) => ({
  ...state,
  isLazyFetching: false,
});

// const _updateStats = (state: Object, action: Object) => {
//   const { result, userId } = action;
//   const user = state[userId];

//   if (user) {
//     return {
//       ...state,
//       [`${userId}`]: {
//         ...user,
//         statistics: result,
//       },
//     };
//   }
//   return state;
// };

export default createReducer(initialState, {
  [types.SIMULATE_USERS_FETCH]: setFetchingState,
  [types.FETCH_USERS_REQUEST]: setFetchingState,
  [types.FETCH_USERS_SUCCESS]: setRequestResultUniqAndValidate,
  [types.FETCH_USERS_FAILURE]: unsetFetchingState,
  // Unknown Type, Why?
  // [types.FETCH_USERS_STATISTICS_SUCCESS]: _updateStats,
  [types.LAZY_FETCH_USERS_REQUEST]: _lazyFetchUsersRequest,
  [types.LAZY_FETCH_USERS_SUCCESS]: _lazyFetchUsersSuccess,
  [types.LAZY_FETCH_USERS_FAILURE]: _lazyFetchUsersFailure,
  [marketTypes.INVALIDATE_MARKET]: invalidate,
});
